module.exports = __webpack_public_path__ + "img/Mask Group 2913@2x.72d14024.png";